import {Component, OnInit, Optional} from '@angular/core';
import {LoadingService} from 'src/app/services/loading/loading.service';
import {AlertService} from 'src/app/services/alert/alert.service';
import {BsModalRef} from 'ngx-bootstrap/modal';
import { ColDef, ColGroupDef, GridOptions } from 'ag-grid-community';
import 'ag-grid-enterprise';
import { HhgCarrierRateFilingService } from '../hhg-carrier-rate-filing/hhg-carrier-rate-filing.service';
import {formatDate} from "@angular/common";

@Component({
    selector: 'tsp-status-portal',
    templateUrl: './tsp-frt-status-portal.component.html',
    styleUrls: ['./tsp-frt-status-portal.component.css'],
    standalone: false
})

export class TspFrtStatusPortalComponent implements OnInit {
  rawData: any;
  carrierRateProcurementGridOptions: GridOptions = this.initializeGridOptions();
  carrierColumnDefs: any;
  format = 'MM/dd/yyyy';
  locale = 'en-US';
  closeBtnName: string;
  constructor(private alertService: AlertService,
              private loader: LoadingService,
              private hhgCarrierRateFilingService : HhgCarrierRateFilingService,
              @Optional() private bsModalRef?: BsModalRef){}

  ngOnInit(): void {
    this.loader.show()
    this.loadRawData();
    this.carrierRateProcurementGridOptions = this.initializeGridOptions();
    this.carrierColumnDefs = this.carrierRateProcurementColumnDefs();
  }

  carrierRateProcurementColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
      {
        headerName: 'SCAC',
        field: 'scac',
        filter: 'agTextColumnFilter'
      },

      {
        headerName: 'Temp Non-Use Date',
        field: 'suspendedDate',
        filter: 'agTextColumnFilter',
        cellRenderer: (params) => {
          return params.data.suspendedDate ? (formatDate(params.data.suspendedDate , this.format, this.locale)) : 'Not Available';
        },
        valueGetter: (params) => {
          return params.data.suspendedDate ? (formatDate(params.data.suspendedDate , this.format, this.locale)) : 'Not Available';
        }
      },
      
      {
        headerName: 'Notes',
        filter: 'agTextColumnFilter',
        field: 'approvalNotes'
      }
    ];
  }

  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      headerHeight: 50,
      pagination: true,
      paginationPageSize: 10,
      cacheBlockSize: 10,
      domLayout: 'autoHeight',
      rowData: this.rawData,
      defaultCsvExportParams: {
        fileName: 'FRT_TSPs_In_Temp_NonUse_Report'
      },
      defaultExcelExportParams: {
        fileName: 'FRT_TSPs_In_Temp_NonUse_Report'
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
    };
  }

  loadRawData(){
    this.hhgCarrierRateFilingService.getInactiveFRTTSP().subscribe(inactiveHHGTSP => {
      this.rawData = inactiveHHGTSP;
      this.rawData.sort((a, b) => {
        return (a.scac > b.scac) ? 1 : -1;
      });
      this.loader.hide();
    }, () => {
      this.loader.hide();
      this.alertService.error('There was an error retrieving HHG Rate Types List');
    });
  }

  close(){
    if (this.closeBtnName && this.closeBtnName.length > 0) this.bsModalRef.hide();
  }
}
